import $ from "jquery";

const init = () => {
  changeCategoryHeader();
};

const changeCategoryHeader = () => {
  const el = {
    data: "#js-CategoryHeader",
  };

  if ($(el.data).length === 0) return;

  const data = $(el.data).data("data");

  console.log(data);

  $(".js-shopHeader").css("background-image", "url(" + data.imageUrl + ")");
};

try {
  init();
} catch (error) {
  console.error(error);
}
